import DefaultLayout from "src/components/common/layouts/DefaultLayout"
import SearchResultHeader from "src/components/pages/creator/SearchResultHeader"
import SearchResultTieupItem from "src/components/SearchResultTieupItem"
import HTMLHead from "src/components/utils/HTMLHead"
import React, { useEffect, useRef } from "react"
import routes from "routes"
import { fetchTieups } from "../../../models/tieup/fetchTieups"
import { useInfinityLoad } from "../../../components/hooks/useInfinityLoad"
import { Tieup } from "../../../models/tieup/Tieup"
import { BarLoader } from "react-spinners"
import colors from "../../../config/color"
import { useIntersection, usePrevious } from "react-use"

const LIMIT = 10

const CreatorTieup: React.FC = () => {
  const intersectionRef = useRef<HTMLDivElement | null>(null)
  const intersection = useIntersection(intersectionRef, {})
  const prevIntersection = usePrevious(intersection)
  const fetcher = (pageIndex: number) => {
    return fetchTieups({
      limit: LIMIT,
      offset: pageIndex * LIMIT,
    })
  }

  const { list, loadMore, isLoading, canLoadMore } = useInfinityLoad<Tieup>({
    fetcher,
    fetcherKey: `/v1/tieup/list`,
    displayCount: LIMIT,
  })

  useEffect(() => {
    if (intersection?.isIntersecting && !prevIntersection?.isIntersecting) {
      loadMore()
    }
  }, [intersection?.isIntersecting, prevIntersection?.isIntersecting, loadMore])

  return (
    <DefaultLayout>
      <HTMLHead path="creator/tieup" />
      <main>
        <div className="l-single">
          <SearchResultHeader
            title="最近たいあっぷした作品"
            showTieupToggle={false}
            showSearchLink={false}
            showOrder={false}
            isTieupList={true}
          />
          <div className="p-searchNovalResult-list">
            {list &&
              list.map((tieup) => (
                <SearchResultTieupItem
                  title={tieup.novel.title}
                  key={tieup.novel.id}
                  thumbnail={tieup.novel.coverImage}
                  catchCopy={tieup.novel.catchCopy}
                  genres={tieup.novel.genres}
                  hashtags={tieup.novel.hashtags}
                  link={routes.viewerCover(tieup.novel.id)} // たいあっぷ作品なので表紙に遷移させる
                />
              ))}
          </div>
          <div ref={intersectionRef}>
            <div className="p-button -spacer-sm">
              {canLoadMore && !isLoading && (
                <button
                  className="c-button-secondary -outline -full"
                  onClick={loadMore}
                >
                  もっと見る
                </button>
              )}
            </div>

            {isLoading && (
              <div className="bar-loader-container">
                <BarLoader color={colors.spectrum.tieupTheme} />
              </div>
            )}
          </div>
        </div>
      </main>
    </DefaultLayout>
  )
}

export default CreatorTieup
